<!--
 * @Description: (弹框)商户签约组件
 * @Author: gaohc
 * @Date: 2022-10-09 16:43:52
-->
<template>
  <div class="drawer-wrap">
    <el-drawer :size="996" title="签约" :before-close="handleCancel" :visible.sync="visible" 
	    direction="rtl" @open="initData">
      <div class="review-result-wrap" v-if="contractData && contractData.review">
        <review-history :review="contractData.review"></review-history>
      </div>
      <div class="signing-qrcode-wrap">
        <div class="title">签约</div>
        <div>请使用超级管理员（法人）的微信扫码进行签约</div>
        <el-image class="qr-code" :src="contractData.signPhotoBase"></el-image>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import Constant from "@/global/Constant.js"
import ReviewHistory  from "../ReviewHistory.vue"

export default {
  name: "MchSigning",
  props: ["visible", "mchId"],
  components: {
    "review-history": ReviewHistory
  },

  data() {
    return {
      contractData: {}
    };
  },

  methods: {
    handleCancel() {
      this.clearData();
      this.$emit("close-dialog", false);
    },

    initData() {
      let params = {id: this.mchId};
      let header = this.encryptionUtil.signatureParams(params, 
        Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
      let requestData = {
        method: 'GET', 
        url: Constant.URL_GET_MERCHANT_SIGNING_DO,
        param: params,
        header: header,
        contentType: this.commonConst.CNTYPE_URLENCODED
      };
      this.vueRequest(requestData).then((result) => {
				if (result == null) {
					return
				}
				this.contractData = result.data;
        this.contractData.review.reviewHistoryList = result.data.reviewHistoryList;
			})
    },

    clearData() {
       this.contractData = {};
    }
  },
};
</script>

<style scoped>
.review-result-wrap {
  padding: 0 60px;
  margin-top: 20px;
}
.qr-code {
  width: 272px;
  height: 272px;
  margin-top: 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/review/components/mchReviewList/MchSigning.vue